import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgShoppingCart = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M25.172 6.439a.876.876 0 0 0-.672-.314H6.856L6.19 2.469a.875.875 0 0 0-.861-.719H2.625a.875.875 0 0 0 0 1.75h1.969l2.795 15.344c.083.455.284.88.583 1.233A3.062 3.062 0 1 0 12.83 21h4.967a3.062 3.062 0 1 0 2.766-1.75H9.973a.875.875 0 0 1-.861-.719l-.347-1.906h12.688a2.625 2.625 0 0 0 2.582-2.156l1.33-7.313a.875.875 0 0 0-.192-.717ZM11.375 22.312a1.313 1.313 0 1 1-2.626 0 1.313 1.313 0 0 1 2.626 0Zm10.5 0a1.313 1.313 0 1 1-2.626 0 1.313 1.313 0 0 1 2.626 0Zm.438-8.156a.875.875 0 0 1-.865.719H8.446l-1.272-7H23.45l-1.139 6.281Z" />
  </svg>
);
export default SvgShoppingCart;
